"use strict";
// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/util/errorObject.js
// module id = 26
// module chunks = 33